export let GlobalVariables = {
	devMode: null,
	isMobile: null,
	reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
	resizeCallbacks: [],
	mobileResizeCallbacks: [],
	lenis: null,
	header: null
};
